import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  viewBox: "0 0 122.88 122.88"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-width": "1.5",
      d: "M61.44 0C27.51 0 0 27.51 0 61.44s27.51 61.44 61.44 61.44 61.44-27.51 61.44-61.44S95.37 0 61.44 0zM47 38h12v47H47zm17 0h12v47H64z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }